import {connect, useDispatch, useSelector} from "react-redux";
import React, {useCallback, useMemo, useRef, useState} from "react";
import dayjs from "dayjs";
import * as formatter from "../../../../config/formatter";
import {CAlert, CButton, CCol, CForm, CFormSelect, CInputGroup, CInputGroupText} from "@coreui/react";
import {DatePicker} from "antd";
import locale from "antd/es/date-picker/locale/ko_KR";
import {Loading} from "../../../../components/common";
import {AgGridReact} from "ag-grid-react";
import * as o2Api from "../../../../api/api";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";
import {gridColumnAvg, gridColumnSum} from "../../../../config/common";

const SaleReport = (props) => {
    const dispatch = useDispatch();
    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        visible: false,
        message: ""
    });
    const [searchForm, setSearchForm] = useState({
        cmpCd: "", brandCd: "", storeCd: "", cornerCd: "",
        saleDt: dayjs().add(-1, "d"),
        closeYn: ""
    });

    const defaultColDef = {
        width: 100,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [columnDefs] = useState([
        {field: "statTime", headerName: "영업일자", maxWidth: 80, cellClass: "static-cell"},
        {
            colId: "week",
            field: "statTime",
            headerName: "요일",
            maxWidth: 60,
            cellClass: "static-cell",
            valueFormatter: (e) => formatter.weekendFormatter(e, "YYYYMMDD"),
        },
        {colId: "storeCd", field: "storeCd", headerName: "매장코드", maxWidth: 80, cellClass: "static-cell"},
        {colId: "storeNm", field: "storeNm", headerName: "매장명",},
        {colId: "posCd", field: "posCd", headerName: "POS", maxWidth: 60, cellClass: "static-cell"},
        {colId: "closeYn", field: "closeYn", headerName: "마감구분", maxWidth: 80, hide: true, cellClass: "static-cell"},
        {colId: "closeYnNm", field: "closeYnNm", headerName: "마감구분", maxWidth: 80, cellClass: "static-cell"
            ,cellStyle: (e) => {
                if (e.value !== '일마감') {
                    return {color: "red", cursor: "pointer"};
                }
                return null;
            }
        },
        {field: "saleAmt", headerName: "총매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "rejectAmt", headerName: "반품금액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "dcAmt", headerName: "총할인액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "vaultAmt", headerName: "실매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "netAmt", headerName: "공급가액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "vatAmt", headerName: "부가세액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "taxAmt", headerName: "과세매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "taxFreeAmt", headerName: "면세매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {
            colId: "openTime",
            field: "openTime",
            minWidth: 150,
            headerName: "개점일시",
            valueFormatter: (e) => formatter.timeFormatter(e, "YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DD HH:mm:ss")
        },
        {
            colId: "closeTime",
            field: "closeTime",
            headerName: "마감일시",
            minWidth: 150,
            valueFormatter: (e) => formatter.timeFormatter(e, "YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DD HH:mm:ss")
        }
    ]);

    const search = () => {
        setError({visible: false, message: ""});

        const {cmpCd, brandCd, storeCd} = searchForm;
        if (brandCd.length === 0) {
            setError({
                visible: true,
                message: "조회시 휴게소는 반드시 선택하셔야 합니다."
            });
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            fromSaleDt: searchForm.saleDt.format("YYYYMMDD"),
            toSaleDt: searchForm.saleDt.format("YYYYMMDD"),
            closeYn: searchForm.closeYn
        };

        console.log("params:: ", params);

        setLoading(true);
        o2Api.getCloseDailySale(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("result : ", responseBody);

            if (responseCode === "200") {
                // 성공
                setRowData(responseBody);
                setLoading(false);

                createBottomTotalRowData(responseBody);
            }
        });
    };

    const setPrinterFriendly = (api) => {
        api.sizeColumnsToFit({
            defaultMinWidth: 80,
            columnLimits: [
                {key: "storeNm", minWidth: 150},
                {key: "openTime", minWidth: 150},
                {key: "closeTime", minWidth: 150},
            ]
        });
        api.setDomLayout("print");
    };

    const setNormal = (api) => {
        const eGridDiv = document.querySelector("#myGrid");
        eGridDiv.style.width = "100%";
        eGridDiv.style.height = "500px";
        api.setDomLayout();

        const htmlTitle = document.querySelector("title");
        htmlTitle.innerHTML = "휴게소 영업정보시스템"
    };

    const onBtPrint = useCallback(() => {
        const htmlTitle = document.querySelector("title");
        htmlTitle.innerHTML = "휴게소 영업 마감현황"

        const api = gridRef.current.api;
        dispatch({ type: 'set', sidebarShow: false })

        setPrinterFriendly(api);
        setTimeout(function () {
            print();
            setNormal(api);
            dispatch({ type: 'set', sidebarShow: true })
        }, 1000);
    }, [print])

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
            }));
        }
    }

    const [bottomTotalRowData] = useState([
        {storeCd: "합계"}
    ])

    const createBottomTotalRowData = (data) => {
        const api = gridRef.current.api;
        const result = [];
        result.push({
            storeCd: "합계",
            saleAmt: gridColumnSum(data, 'saleAmt'),
            rejectAmt: gridColumnSum(data, 'rejectAmt'),
            dcAmt: gridColumnSum(data, 'dcAmt'),
            vaultAmt: gridColumnSum(data, 'vaultAmt'),
            netAmt: gridColumnSum(data, 'netAmt'),
            vatAmt: gridColumnSum(data, 'vatAmt'),
            payAmt: gridColumnSum(data, 'payAmt'),
            taxAmt: gridColumnSum(data, 'taxAmt'),
            taxFreeAmt: gridColumnSum(data, 'taxFreeAmt')
       });
        api.setPinnedBottomRowData(result);
    }

    return (
        <div style={containerStyle}>
            {loading ? <Loading/> : null}
            {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
            <div className="d-md-flex align-items-center justify-content-between p-1">
                <h5 className={"hidden-print"}>일일영업 판매보고서</h5>
            </div>
            <div id={"title"} className={"visible-print"}>
                <center>
                    <h2>휴게소 영업 마감현황</h2>
                </center>
            </div>
            <div className={"hidden-print"}>
                <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
                <div className={"row row-cols-lg-auto g-1 m-0 align-items-center"}>
                    <CCol xs={12} md={6}>
                        <CInputGroup size={"sm"}>
                            <CInputGroupText style={{width: 80}}>영업일자</CInputGroupText>
                            <CInputGroupText style={{background: "white", height: 35}}>
                                <DatePicker bordered={false}
                                            separator={"~"}
                                            placeholder={""}
                                            locale={locale}
                                            value={searchForm.saleDt}
                                            onChange={(dayjs, dateString) => {
                                                setSearchForm((state) => ({
                                                    ...state, saleDt: dayjs
                                                }));
                                            }}/>
                            </CInputGroupText>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12} md={6}>
                        <CInputGroup size={"sm"}>
                            <CInputGroupText style={{width: 80}}>마감구분</CInputGroupText>
                            <CFormSelect id="closeYn"
                                         onChange={(e) => {
                                             setSearchForm((state) => ({
                                                 ...state,
                                                 closeYn: e.target.value
                                             }));
                                         }}
                            >
                                <option value={""}>전체</option>
                                <option value={"Y"}>일마감</option>
                                <option value={"N"}>(미)마감</option>
                            </CFormSelect>
                        </CInputGroup>
                    </CCol>
                    <div className={"d-grid d-md-flex gap-1"}>
                        <CButton style={{minWidth: 50, height: 35}} size={"sm"} color={"primary"} onClick={onBtPrint}>출력</CButton>
                        <CButton style={{minWidth: 50, height: 35}} size={"sm"} color={"primary"} onClick={search}>조회</CButton>
                    </div>
                </div>
            </div>
            <div id="myGrid" className="ag-theme-alpine" style={{width: "100%", height: 500, marginTop: 10}}>
                <AgGridReact
                    ref={gridRef}
                    suppressSizeToFit={true}
                    rowSelection={"multiple"}
                    enableRangeSelection={true}
                    enableCellTextSelection={true}
                    suppressClipboardPaste={true}
                    localeText={{noRowsToShow: "조회 결과가 없습니다."}}
                    rowData={rowData}
                    animateRows={true}
                    pinnedBottomRowData={bottomTotalRowData}
                    defaultColDef={defaultColDef}
                    columnDefs={columnDefs}>
                </AgGridReact>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(SaleReport);
